import { Box } from "@mui/material"
import type { FC } from "react"

import { AS400_APPROVAL_SYNC_PENDING_LABEL } from "../constants/invoiceAs400Sync"
import { INVOICE_STATUS_CHIP_CLASSES, INVOICE_STATUS_LABELS } from "../constants/labels"
import { isApproveSyncFailed, isApproveSyncInProgress } from "../utils/invoiceAs400Sync"

import { InvoiceAs400SyncIndicator } from "./InvoiceAs400SyncIndicator"

import StyledChip from "@/components/common/Chip/Chip"
import { type Invoice, InvoiceStatus } from "@/graphql/codegen/graphql"

interface InvoiceStatusCellProps {
  invoice: Invoice
}

export const InvoiceStatusCell: FC<InvoiceStatusCellProps> = ({ invoice }) => {
  // AK-5232 AC2/AC3: an approved invoice is not fully approved until AS400 confirms the voucher.
  const isApprovalSyncPending = isApproveSyncInProgress(invoice)
  const isApprovalSyncStillOpen = isApprovalSyncPending || isApproveSyncFailed(invoice)
  const chipStatus = isApprovalSyncStillOpen ? InvoiceStatus.PendingApproval : invoice.status
  const label = isApprovalSyncPending ? AS400_APPROVAL_SYNC_PENDING_LABEL : INVOICE_STATUS_LABELS[chipStatus]

  return (
    <Box className='flex items-center gap-1'>
      <StyledChip label={label} className={INVOICE_STATUS_CHIP_CLASSES[chipStatus]} size='small' />
      <InvoiceAs400SyncIndicator invoice={invoice} />
    </Box>
  )
}
